import React from 'react'

export const GridIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    {/* Top Row */}
    <rect x="1" y="1" width="4" height="4" rx="1" />
    <rect x="6" y="1" width="4" height="4" rx="1" />
    <rect x="11" y="1" width="4" height="4" rx="1" />

    {/* Middle Row */}
    <rect x="1" y="6" width="4" height="4" rx="1" />
    <rect x="6" y="6" width="4" height="4" rx="1" />
    <rect x="11" y="6" width="4" height="4" rx="1" />

    {/* Bottom Row */}
    <rect x="1" y="11" width="4" height="4" rx="1" />
    <rect x="6" y="11" width="4" height="4" rx="1" />
    <rect x="11" y="11" width="4" height="4" rx="1" />
  </svg>
)
